import { Box } from "@material-ui/core";
import React from "react";
import CheckboxComponent from "../../../../Common/Checkboxes/CheckboxComponent";

const SignableDocumentsCheckboxesSection = ({
  isActive,
  handleIsActiveChange,
  isDefault,
  handleIsDefaultChange,
  isDefaultAccepted,
  handleIsDefaultAcceptedChange,
  isAcceptanceMandatory,
  handleIsAcceptanceMandatoryChange,
  isLocked,
  handleIsLockedChange,
  isWarranty,
  handleIsWarrantyChange,
  resources
}) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start">
      <CheckboxComponent
        label={resources["IsActive"]}
        id="signable-documents-is-active"
        checked={isActive}
        onChange={handleIsActiveChange}
      />

      <CheckboxComponent
        label={resources["IsDefault"]}
        id="signable-documents-is-default"
        checked={isDefault}
        onChange={handleIsDefaultChange}
      />

      <CheckboxComponent
        label={resources["IsDefaultAccepted"]}
        id="signable-documents-is-default-accepted"
        checked={isDefaultAccepted}
        onChange={handleIsDefaultAcceptedChange}
      />

      <CheckboxComponent
        label={resources["IsAcceptanceMandatory"]}
        id="signable-documents-is-acceptance-mandatory"
        checked={isAcceptanceMandatory}
        onChange={handleIsAcceptanceMandatoryChange}
      />

      <CheckboxComponent
        label={resources["IsLocked"]}
        id="signable-documents-is-locked"
        checked={isLocked}
        onChange={handleIsLockedChange}
      />

      <CheckboxComponent
        label={resources["IsWarranty"]}
        id="signable-documents-is-warranty"
        checked={isWarranty}
        onChange={handleIsWarrantyChange}
      />
    </Box>
  );
};

export default SignableDocumentsCheckboxesSection;
